import { Outlet } from 'react-router';
import { BrandMark } from '@/components/BrandMark';

/** Centered card on the grey canvas — the AP sign-in look. */
export function AuthLayout() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas px-4 py-10">
      <main className="w-full max-w-[405px] rounded-auth bg-white p-5 shadow-auth sm:p-7">
        <BrandMark className="mx-auto mb-6 w-64" />
        <Outlet />
      </main>
    </div>
  );
}
